<br />
<div class="row ">
    <div class="col"></div>
    <div class="col-md-8">
        <form class="text-center">
            <mat-card appearance="outlined">
                <strong>Nuevo comentario de ayuda</strong>
            </mat-card>
            <mat-card appearance="outlined">
                <app-input inputType="text" placeholder="Sección" name="help.section" [isRequired]="true"
                    [(ngModel)]="help.section"></app-input>
                <br />
                <mat-form-field appearance="fill" class="text-center mt-2" style="width:600px;">
                    <mat-label>Descripción</mat-label>
                    <textarea matInput placeholder="Descripción" name="help.description" [(ngModel)]="help.description">
                    </textarea>
                </mat-form-field>
                <br />
                <app-input inputType="text" placeholder="Padre" name="help.parent" [(ngModel)]="help.parent"></app-input>
                <br />
                <app-input inputType="text" placeholder="Keyword" name="help.keyword" [(ngModel)]="help.keyword"></app-input>
            </mat-card>
            <div class="mt-3">
                <button mat-stroked-button (click)="save(help)">
                    <mat-icon>save</mat-icon>
                    Guardar
                </button>
            </div>
        </form>
    </div>
    <div class="col"></div>
</div>
<br />
<p class="text-center">
    <strong>Los campos marcados con *, son obligatorios</strong>
</p>
<p class="text-center">
    <strong>*Consejo:</strong> Puedes usar el tabulador para ir cambiando de campo</p>